import React, { useState, useMemo } from 'react';
import LoadData from './LoadData';
import BackupAndRestore from './BackupAndRestore';
import SqlExport from './SqlExport';
import FileUpload from './FileUpload';
import ServerUrl from './ServerUrl';

const operations = [
  { id: 'backup-restore', name: 'Backup & Restore', icon: 'bi-arrow-left-right' },
  { id: 'load-data', name: 'Load Data', icon: 'bi-file-earmark-arrow-up' },
  { id: 'sql-export', name: 'SQL Export', icon: 'bi-file-earmark-code' },
  { id: 'file-upload', name: 'File Upload', icon: 'bi-file-arrow-up' },
  { id: 'server-url', name: 'URL', icon: 'bi-link-45deg' }
];

const Operations = ({ onTablesUpdate }) => {
  const [selectedOperation, setSelectedOperation] = useState('backup-restore');
  const [searchTerm, setSearchTerm] = useState('');

  // Filter operations based on search term
  const filteredOperations = useMemo(() => {
    if (!searchTerm.trim()) {
      return operations;
    }
    return operations.filter(operation =>
      operation.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };


  const renderOperationContent = () => {
    switch (selectedOperation) {
      case 'backup-restore':
        return <BackupAndRestore onTablesUpdate={onTablesUpdate} />;

      case 'load-data':
        return <LoadData onTablesUpdate={onTablesUpdate} />;

      case 'sql-export':
        return <SqlExport />;

      case 'file-upload':
        return <FileUpload />;

      case 'server-url':
        return <ServerUrl />;

      default:
        return (
          <div>
            <h2 className="title is-3">Select an Operation</h2>
            <p>Choose an operation from the left panel to get started.</p>
          </div>
        );
    }
  };

  return (
    <div className="container is-fluid" style={{ paddingTop: '2rem', paddingBottom: '2rem', minHeight: 'calc(100vh - 120px)' }}>
      <div className="columns is-fullheight">
        {/* Left Panel - Operations Menu */}
        <div className="column is-3">
          <div className="panel">
            <p className="panel-heading">
              Operations
            </p>

            {/* Search Input */}
            <div className="panel-block">
              <p className="control has-icons-left">
                <input
                  className="input is-small"
                  type="text"
                  placeholder="Search operations..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
                <span className="icon is-small is-left">
                  <i className="bi bi-search"></i>
                </span>
              </p>
            </div>

            {/* Operations List */}
            {filteredOperations.map((operation) => (
              <a
                href="#!"
                key={operation.id}
                className={`panel-block ${selectedOperation === operation.id ? 'is-active' : ''}`}
                onClick={() => setSelectedOperation(operation.id)}
                style={{ cursor: 'pointer' }}
              >
                <span className="panel-icon">
                  <i className={operation.icon} aria-hidden="true"></i>
                </span>
                {operation.name}
              </a>
            ))}

            {/* Show message when search has no results */}
            {filteredOperations.length === 0 && searchTerm.trim() && (
              <div className="panel-block">
                <div className="content">
                  <p>No operations found matching "{searchTerm}".</p>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Right Panel - Operation Content */}
        <div className="column">
          <div className="content" style={{ width: '100%', overflow: 'hidden' }}>
            {renderOperationContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Operations;